export enum MVCellBlock {
  Root = 'MVCell',
}
